export default __webpack_public_path__ + "static/media/treadmill.c61bdb73.jpeg";